import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import AddPriceConfig from './addConfig';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { showPlatform } from '@/util';

@Component({
  components: {
    AddPriceConfig,
  },
  mixins: [style],
})
export default class ProductFilterConfig extends Vue {
  public priceConfig: PriceConfigClass = {
    isOpen: 0,
    configList: [],
  };

  public zkConfig: PriceConfigClass = {
    isOpen: 0,
    configList: [],
  };

  $refs: {
    form: ElForm;
  };

  public isSearchSize = 0;

  showPlatform=showPlatform()

  mounted() {
    IPSService.getSiteOtherConfigInfo({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
      },
    }).then((response) => {
      this.priceConfig = Object.assign({}, this.priceConfig, response.priceConfig);
      this.zkConfig = Object.assign({}, this.zkConfig, response.zkConfig);
      this.isSearchSize = response.isSearchSize || 0;
    });
  }

  /**
   * 保存可提/可售配置
   */
  public onSave() {
    const { priceConfig, zkConfig, isSearchSize } = this;
    const result = this.priceConfig.isOpen
      ? this.priceConfig.configList.map((val, i) => {
        return (this.$refs[`inputForm${i}`].$refs['inputForm'] as ElForm).validate();
      })
      : [];
    const resultb = this.zkConfig.isOpen
      ? this.zkConfig.configList.map((val, i) => {
        return (this.$refs[`zkForm${i}`].$refs['zkForm'] as ElForm).validate();
      })
      : [];
    const resulta = result.concat(resultb).filter(Boolean);
    if (resulta) {
      Promise.all(resulta).then((res) => {
        if (res) {
          if (this.totalContent !== 100 && priceConfig.isOpen) {
            this.$message.warning('选择人数百分比之和必须为100%，请确认！');
            return;
          }
          if (zkConfig.isOpen) {
            zkConfig.configList.map((i) => {
              if (i.isShow === 0) {
                i.content = '';
              }
              return i;
            });
          }
          IPSService.saveSiteOtherConfig({
            postParams: {
              siteId: Number.parseInt(this.$route.params.siteId),
              priceConfig,
              zkConfig,
              isSearchSize,
            },
          }).then((response) => {
            if (response.result) {
              this.$message.success('保存成功');
            }
          });
        }
      });
    }
  }

  get totalContent() {
    const initNum = 0;
    return this.priceConfig.configList.reduce((a, b) => {
      return a + Number(b.content);
    }, initNum);
  }

  addDefaultConfig(val, flag) {
    if (flag) {
      if (this.priceConfig.configList.length === 0 && val) {
        this.priceConfig.configList.push({ min: 0, max: '+oo', content: 0 });
      }
    } else {
      if (this.zkConfig.configList.length === 0 && val) {
        this.zkConfig.configList.push({ min: 0, max: 100, content: '', isShow: 0 });
      }
    }
    if (!val) {
      flag ? (this.priceConfig.configList = []) : (this.zkConfig.configList = []);
    }
  }

  addPriceConfig(flag) {
    if (flag) {
      if (this.priceConfig.configList.length === 11) {
        this.$message.error('最多只能添加11个价格区间！');
        return;
      }
      this.priceConfig.configList.push({
        min: 500,
        max: '+oo',
        content: 0,
      });
    } else {
      if (this.zkConfig.configList.length === 11) {
        this.$message.error('最多只能添加11个折扣段！');
        return;
      }
      this.zkConfig.configList.push({
        min: 0,
        max: 100,
        content: '',
        isShow: 0,
      });
    }
  }

  minusPriceConfig(i, flag) {
    const length = flag ? this.priceConfig.configList.length : this.zkConfig.configList.length;
    if (flag) {
      console.log('priceCOnfig---');
      length === i + 1 ? this.priceConfig.configList.splice(i, 1) : this.priceConfig.configList.splice(length - 2, 1);
    } else {
      console.log('zkCOnfig---');
      length === i + 1 ? this.zkConfig.configList.splice(i, 1) : this.zkConfig.configList.splice(length - 2, 1);
    }
  }

  changeMax(val, flag) {
    const config = flag ? Object.assign({}, this.priceConfig.configList[val.index + 1], { min: +val.con }) : Object.assign({}, this.zkConfig.configList[val.index + 1], { min: val.con });
    flag ? this.$set(this.priceConfig.configList, val.index + 1, config) : this.$set(this.zkConfig.configList, val.index + 1, config);
  }

  render(h) {
    return (
      <div class="formWrapper">
        <el-form props={{ model: {} }} label-position="top" class="r-px-30 r-pt-2 overflow-auto" ref="form" style="height:calc(100% - 54px)">
          <div class="formItemWrapper guid-tag">
            <div class="blockTitle">商品筛选项配置</div>
            <p class="tip blockTip line-height-24">注：开启下列筛选项展示后，在小程序端的商品列表筛选功能中，将出现相应的筛选项目。</p>
            <el-form-item class="r-ml-24 r-mt-12">
              <el-checkbox class="r-mb-16" v-model={this.priceConfig.isOpen} onChange={val => this.addDefaultConfig(val, 1)} true-label={1} false-label={0}>
                展示价格区间筛选项
              </el-checkbox>
              {this.priceConfig.isOpen ? (
                <div>
                  {this.priceConfig.configList.map((item, index) => {
                    return (
                      <AddPriceConfig
                        isPriceList={true}
                        class="r-ml-24"
                        v-model={item}
                        index={index}
                        key={index}
                        maxFlag={this.priceConfig.configList.length}
                        onAddItem={() => this.addPriceConfig(1)}
                        onMinusItem={() => this.minusPriceConfig(index, 1)}
                        onMaxChange={val => this.changeMax(val, 1)}
                        ref={`inputForm${index}`}
                      />
                    );
                  })}
                </div>
              ) : (
                ''
              )}
            </el-form-item>
            <el-form-item class="r-ml-24 r-mt-12">
              <el-checkbox v-model={this.zkConfig.isOpen} onChange={val => this.addDefaultConfig(val, 0)} true-label={1} false-label={0}>
                展示折扣段筛选项
              </el-checkbox>
              <p class="tip blockTip line-height-24 r-ml-24">注：商品所属折扣段数据，请每晚更新一次！</p>
              {this.zkConfig.isOpen ? (
                <div>
                  {this.zkConfig.configList.map((item, index) => {
                    return (
                      <AddPriceConfig
                        v-model={this.zkConfig.configList[index]}
                        class="r-ml-24"
                        index={index}
                        key={index}
                        maxFlag={this.zkConfig.configList.length}
                        onAddItem={() => this.addPriceConfig(0)}
                        onMinusItem={() => this.minusPriceConfig(index, 0)}
                        onMaxChange={val => this.changeMax(val, 0)}
                        ref={`zkForm${index}`}
                      />
                    );
                  })}
                </div>
              ) : (
                ''
              )}
            </el-form-item>
            {this.showPlatform ? (
              <el-form-item class="r-ml-24 r-mt-12">
                <el-checkbox v-model={this.isSearchSize} true-label={1} false-label={0}>
                  展示尺码筛选项
                </el-checkbox>
                <p class="tip blockTip line-height-24 r-ml-24">注：请预先在【其他配置】/【尺码对照表】中队系统尺码进行维护！</p>
              </el-form-item>
            ) : (
              ''
            )}
          </div>
        </el-form>
        <div class="bottomWrapper border-top-white">
          <el-button type="primary" onClick={this.onSave.bind(this)}>
            保存
          </el-button>
        </div>
      </div>
    );
  }
}
